// extracted by mini-css-extract-plugin
export default {"grid":"FullPhoto_grid__vommo","column":"FullPhoto_column__EePVv","preview":"FullPhoto_preview__5HH1a","foot":"FullPhoto_foot__0ad7h"};